import {
  FETCH_TOURNAMENT_REQUESTED,
  FETCH_TOURNAMENT_SUCCESS,
  FETCH_TOURNAMENT_FAILURE,
  FETCH_EVENTS_SUCCESS,
  FETCH_EDITIONS_SUCCESS,
  FETCH_ROUNDS_SUCCESS,
} from 'constants/actions'

import {
  fetchTournamentMatches,
  fetchEvents as fetchEventsRequest,
  fetchEditions as fetchEditionsRequest,
  fetchRounds as fetchRoundsRequest,
} from 'api/requests'

export const getTournamentMatches = (params) => async (dispatch) => {
  dispatch({ type: FETCH_TOURNAMENT_REQUESTED })

  try {
    const response = await fetchTournamentMatches(params)
    if (response.data) {
      dispatch({
        type: FETCH_TOURNAMENT_SUCCESS,
        data: { matches: response.data },
      })
    }
  } catch (error) {
    dispatch({
      type: FETCH_TOURNAMENT_FAILURE,
      data: { message: error.response?.data?.error || 'Failed to load tournament matches.' },
    })
  }
}

export const getEvents = (search) => async (dispatch) => {
  try {
    const response = await fetchEventsRequest(search)
    dispatch({ type: FETCH_EVENTS_SUCCESS, data: response.data })
  } catch (error) {
    // silent — filter options are non-critical
  }
}

export const getEditions = (event) => async (dispatch) => {
  try {
    const response = await fetchEditionsRequest(event)
    dispatch({ type: FETCH_EDITIONS_SUCCESS, data: response.data })
  } catch (error) {
    // silent
  }
}

export const getRounds = (event, edition) => async (dispatch) => {
  try {
    const response = await fetchRoundsRequest(event, edition)
    dispatch({ type: FETCH_ROUNDS_SUCCESS, data: response.data })
  } catch (error) {
    // silent
  }
}
